import Hero from "./components/Hero";
import Contact from "./components/Contact";

export default function App() {
  return (
    <div className="App font-Nunito">
      <Hero />
      
      <Contact />
    </div>
  );
}
